import { Api } from "../helpers";

export const apService = {
  getById,
  createAP,
  updateAP,
  deleteAP,
  getList,
  finalizeAP
};

// get the ap by his id
function getById(id) {
  return Api()
    .get("/accept-protocol/" + id)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      //
      return response.data.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// create new ap, pass data
function createAP(data) {
  return Api()
    .post("/accept-protocol", data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// create new ap, pass data
function updateAP(options) {
  return Api()
    .put("/accept-protocol/" + options.id, options.data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data.data;
    })
    .catch(err => {
      console.log("error:", err);
      return Promise.reject(err);
    });
}

// create new ap, pass data
function deleteAP(options) {
  return Api()
    .delete("/accept-protocol/" + options.id)
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// get the list of all accept protools
// {state: 'all}
function getList(options) {
  return Api()
    .get("/accept-protocols", { options })
    .then(response => {
      // return accept-protocols 
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      //
      return response.data.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// mark AP as finalizeed (delete this one anc create completed one)
function finalizeAP(options) {
  return Api()
    .put("/accept-protocol/" + options.id + "/finalize")
    .then(response => {
      // returns id of newly created finalized-accept-protocol
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

